import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { hasPath, path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';

const PasswordInputs = () => {
	const {
		control,
		formState: { errors }
	} = useFormContext();

	return (
		<>
			<Grid item xs={12} sm={6}>
				<Controller
					name="password1"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							type="password"
							variant="outlined"
							label="Password"
							{...field}
							helperText={path(['password1', 'message'], errors)}
							error={hasPath(['password1', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Controller
					name="password2"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="Confirm Password"
							type="password"
							helperText={path(['password2', 'message'], errors)}
							error={hasPath(['password2', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
		</>
	);
};

export default PasswordInputs;
